const moment = require('moment')
const similarity = require("similarity");
const { isSimilar, normalizeString } = require("../helpers/similarityHelper");
const {
  ADR_TYPE_ID,
  VEHICLE_CAPACITY,
  SIMILARITY_THRESHOLD
} = require("../constants");
/**
 * ---------------
 * Belirli bir aracın, verilen bir siparişi alıp alamayacağını kontrol eder. Örneğin, aracın 18 Nisan'da
 * bir iş aldığını ve 19 Nisan'da 12:30'da teslim edeceğini varsayalım. Bu işlev, 19 Nisan 12:30'dan sonraki
 * siparişler için aracın mevcut konumunu ve sonraki siparişlerin teslim noktalarını kontrol ederek, aracı uygun
 * hale getirir (örneğin, zincirleme siparişler gibi).
 * ---------------
 * @param {Object} vehicle - Kontrol edilecek araç objesi.
 * @param {Object} order - Kontrol edilecek sipariş objesi.
 * @returns {boolean} - Eğer araç belirli bir siparişi alabilirse true, aksi halde false döner.
 */

const { isSequential, isSequentialWithRealRoute } = require("./isSequential");


function isVehicleSuitableForOrderDetail(
  order,
  vehicle,
  products,
  isBulk = false,
  skipTheTonnage = false,
  isClose = false
) {
  let capacity = vehicle?.capacity / 1000;
  if (capacity >= VEHICLE_CAPACITY.SPECIAL_RANGE_MIN / 1000 && capacity <= VEHICLE_CAPACITY.SPECIAL_RANGE_MAX / 1000) {
    capacity = VEHICLE_CAPACITY.SPECIAL_RANGE_ADJUSTED;
  }
  let isTonnageSuitable = order.tonnage <= capacity || isBulk || skipTheTonnage;

  //let sequentialResult = vehicle.orderNos?.length > 0 ? isSequentialWithRealRoute(vehicle, order) : false;
  // Eğer orderNosu boş ise yani üstünde bir iş yoksa araç için zaten ardışık kontrolüne gerek yok
  // eğer kuş bakışı hali ile kontrol algoritması true ise birde gerçek km uzaklığı ile kontrol et.
  // bu sayede gereksiz yere gerçek route servisini yorma
  let sequentialResult;
  if (vehicle.orderNos?.length > 0) {
    sequentialResult = isSequential(vehicle, order);
    if (sequentialResult) {
      sequentialResult = isSequentialWithRealRoute(vehicle, order)
    }
  } else { sequentialResult = false }



  // Aracın son işinin durumunu kontrol et
  const hasCompletedLastJob = vehicle?.planning?.stateId === 8 || vehicle?.planning?.state === 8;
  const isWaitingApproval = vehicle?.planning?.stateId === 1 || vehicle?.planning?.state === 1;
  const isStoppedWithOrder = vehicle?.planning?.isStopped === 1 && Array.isArray(vehicle?.orderNos);

  // GEMİ OPERASYONU KONTROLÜ: Gemideki araçlar başka yere önerilemez
  // Salınmış araçlar (isReleasedFromShip = 1) artık gemi operasyonunda sayılmaz
  const isInShipOperation = vehicle?.isShipOperation === true && Number(vehicle?.shipId) > 0 && vehicle?.isReleasedFromShip !== 1;

  // Tek yön canlı atama için: İşini bitirmiş araçlar tekrar atanabilir
  const canTakeNewJob = hasCompletedLastJob || !vehicle?.planning?.stateId || !vehicle?.planning?.state;

  // ✅ İYİLEŞTİRME: Araç toplu planlamada iken orderNos boşsa uygun olmalı
  const hasNoActiveOrders = !vehicle?.orderNos || vehicle?.orderNos.length === 0;

  // Araç uygunluk kontrolü - tek yön canlı atama desteği eklendi
  // GEMİDEKİ ARAÇLAR KESİNLİKLE BAŞKA YERE ÖNERİLEMEZ
  if (isInShipOperation) {
    return {
      isTonnageSuitable: false,
      isVehicleAvailable: false,
      isInspectionAvailable: false,
      dorseAvailable: false,
      isAdrAvailable: false,
      isADRCompatible: false,
      isLastproduct: false,
      reason: 'Araç gemi operasyonunda kilitli'
    };
  }

  // Aktif operasyonda olan araçlar (stateId 1-7 arası) başka işe atanamaz
  // Sadece işini bitirmiş (stateId = 8) veya hiç işi olmayan araçlar atanabilir
  const hasActiveJob = vehicle?.stateId >= 1 && vehicle?.stateId < 8;

  let isVehicleAvailable =
    (Array.isArray(vehicle?.orderNos) && canTakeNewJob
      ? true  // İşini bitirmiş araç, aynı siparişten tekrar iş alabilir
      : vehicle.orderNos?.filter((r) => r != order.orderNo).length == 0
    ) ||
    isStoppedWithOrder ||
    sequentialResult ||
    hasNoActiveOrders ||  // orderNos boşsa uygun (isAvailable false olsa bile)
    (!isWaitingApproval && vehicle?.isAvailable);

  // Aktif işi olan araçlar kesinlikle müsait değil (sequential ve durdurulmuş araçlar hariç)
  if (hasActiveJob && !sequentialResult && !isStoppedWithOrder) {
    isVehicleAvailable = false;
  }

  vehicle.isSequentialTrue = vehicle?.orderNos?.length > 0 ? sequentialResult : false;

  const filteredProducts = products
    .map((pValue) => ({
      product: pValue,
      score: similarity(
        normalizeString(pValue?.name),
        normalizeString(order?.productName || order?.productType)
      ),
    }))
    .filter((item) => item.score >= SIMILARITY_THRESHOLD.CLOSE_MATCH);
  const findProduct = filteredProducts.length
    ? filteredProducts.reduce((bestMatch, item) =>
      item.score > bestMatch.score ? item : bestMatch
    ).product
    : null; // Eğer uygun ürün yoksa `null` döndür



  if (!findProduct) {
    console.log("ürün uygun değil");
    return {
      isTonnageSuitable: false,
      isVehicleAvailable: false,
      isInspectionAvailable: false,
      dorseAvailable: false,
      isAdrAvailable: false,
      isADRCompatible: false,
      isLastproduct: false,
    }; // Ürün bulunamazsa, araç uygun değildir.
  }

  // Ürünün ADR'li olup olmadığını kontrol et
  //Muayenesi bitmiş araçların ve siparişin teslim tarihinden önce bitecek araçları false döndürüyoruz.
  const vehicleIsRent = vehicle.haveType ? vehicle.haveType : vehicle.isRent;
  const productRequiresADR = findProduct.typeId === ADR_TYPE_ID;

  let isInspectionAvailable =

    (vehicle.isDorseRent == 1 ? true
      : moment(vehicle.inspectionEndDate).diff(moment(), "days") > 0 &&
      moment(vehicle.inspectionEndDate).diff(moment(order?.deliveryDate), "days") > 0) &&
      (vehicleIsRent == 1
        ? true
        : moment(vehicle.vehicleInspectionEndDate).diff(moment(), "days") > 0 &&
        moment(vehicle.vehicleInspectionEndDate).diff(
          moment(order?.deliveryDate),
          "days"
        ) > 0)
      ? true
      : false;

  let isAdrAvailable =
    (vehicleIsRent == 1
      ? true
      : moment(vehicle.vehicleAdrEndDate).diff(moment(), "days") > 0 &&
      moment(vehicle.vehicleAdrEndDate).diff(
        moment(order?.deliveryDate),
        "days"
      ) > 0) &&
      (vehicle.isDorseRent == 1
        ? true
        : moment(vehicle.dorseAdrEndDate).diff(moment(), "days") > 0 &&
        moment(vehicle.dorseAdrEndDate).diff(
          moment(order?.deliveryDate),
          "days"
        ) > 0)
      ? true
      : false;
  let isSrcAvailable =
    vehicleIsRent == 1 || !productRequiresADR
      ? true
      : moment(vehicle.srcEndTime).diff(moment(), "days") > 0 &&
        moment(vehicle.srcEndTime).diff(moment(order?.deliveryDate), "days") > 0
        ? true
        : false;

  const ADRVehicle = vehicle?.transportPurpose?.includes("TEHLİKELİ");

  // Eğer Tehlikeli ürün değilse adr uygunluğuna bakmasın
  isAdrAvailable = productRequiresADR ? isAdrAvailable : true;

  let haveTypeAvailable = true;

  if (order.haveType && order.haveType != 3) {
    // kiralık
    haveTypeAvailable = order.haveType == vehicle.haveType;
    // 1 ise kiralık
    // 2 ise özmal olmalı
  }

  // Araçta bu dorse türü olup olmadığını kontrol et (kırkayak dahil tüm siparişler için)
  const findDorseType = findProduct.dorseTypes.filter((find) => {
    if (typeof find.name == "string" && typeof vehicle.romorkType == "string") {
      if (
        isSimilar(
          normalizeText(find?.name),
          normalizeText(vehicle?.romorkType),
          SIMILARITY_THRESHOLD.CLOSE_MATCH
        )
      ) {
        return find;
      }
    }
  });
  const dorseAvailable = findDorseType.length > 0;

  // eğer araç ihtiyacı kırk ayak ise buradaki öneri yapısı çalışarak uygun arabaları döndürür
  if (order.tonnage <= VEHICLE_CAPACITY.SMALL_ORDER_LIMIT && isClose) {
    const isTonnageSuitable =
      vehicle.capacity >= VEHICLE_CAPACITY.CENTIPEDE_MIN && vehicle.capacity <= VEHICLE_CAPACITY.CENTIPEDE_MAX;

    const productName = order?.productName
      ? order?.productName
      : order?.productType;
    const vehicleLastProduct = vehicle?.isSequentialTrue ? vehicle.productId : vehicle.lastProduct;
    return {
      haveTypeAvailable: haveTypeAvailable,
      isTonnageSuitable,
      isVehicleAvailable,
      dorseAvailable,  // Artık gerçek dorse kontrolü yapılıyor
      isADRCompatible:
        !productRequiresADR || (productRequiresADR && ADRVehicle),
      isInspectionAvailable,
      isAdrAvailable,
      isSrcAvailable,
      lastProductAvailable: !vehicleLastProduct
        ? 3
        : isSimilar(vehicleLastProduct, productName, SIMILARITY_THRESHOLD.CLOSE_MATCH)
          ? 1
          : 2,
    };
  }

  const allADRDorse = vehicle?.romorkType?.includes("ADR");

  const productName = order?.productName
    ? order?.productName
    : order?.productType;

  const isADRCompatible =
    !productRequiresADR || (productRequiresADR && allADRDorse && ADRVehicle);


  // Aracın sequential (canlı atama) olup olmadığını kontrol et
  const isLiveAssignment = isSequential(vehicle, order);

  const result = {
    isTonnageSuitable,
    isVehicleAvailable,
    haveTypeAvailable,
    dorseAvailable,
    isADRCompatible,
    isSrcAvailable,
    isInspectionAvailable,
    isAdrAvailable,
    isLiveAssignment,
    lastProductAvailable: !vehicle?.lastProduct
      ? 3
      : isSimilar(vehicle?.lastProduct, productName, SIMILARITY_THRESHOLD.CLOSE_MATCH)
        ? 1
        : 2,
  };

  return result;
}
const normalizeText = (text) =>
  typeof text === "string"
    ? text.replace(/\s+/g, "").toLowerCase()
    : "";

module.exports = {
  isVehicleSuitableForOrderDetail
}